import { OnInit, Component } from '@angular/core';
import { ReqResService } from '../../service/req-res.service';
import { PaginationInstance } from 'ngx-pagination';
import { PluginService } from '../../service/plugin.service';
import { Title } from '@angular/platform-browser';
declare var $: any;
declare var toastr: any;
@Component({
  selector: 'app-statuses',
  templateUrl: './statuses.component.html',
  styleUrls: ['./statuses.component.css']
})
export class StatusesComponent implements OnInit {
  loading = false;
  status: any[];
  sortReverse: boolean;
  sortType: string = 'default';
  searchStatus: string = '';

  statusObj: any = {};
  statusObjTemp: any = {};

  //del variables
  delId: number;
  delType: string;
  delCount: number;
  delBulkArray: any = [];
  delType2: string;
  statusCount: number = 0;
  maxCount: number = 0;
  sortdirection: string = 'D';

  public _pluginservice;
  constructor(private reqRes: ReqResService, private pluginservice: PluginService, private titleService: Title) {
    this.titleService.setTitle('Statuses');
    this._pluginservice = this.pluginservice;
  };
  ngOnInit(): void {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
    this.sortReverse = true;
    this.sortType = 'default';
    let json = {
      "Search": '',
      "Count": this.statusCount,
      "Direction": 'D',
      "SortType": this.sortType
    };
    this.getStatus(JSON.stringify(json), 0);
    this._pluginservice.masterSelectedRefresh('statusBulk', []);
    this._pluginservice.checkedList = [];
  }

  searchInputOperation() {
    $("[data-toggle='tooltip']").tooltip('hide');
  }
  openFilter() {
    $(`#divSearchFilter`).removeClass("d-none")
    $(`#divSearchFilter`).addClass("d-inline-block")
    $(`#divSearchFilter`).animate({ right: '0px' }, "slow");
    $(`#btnSearchFilter`).hide();
    $(`#inputSearchFilter`).focus();
  }
  closeFilter() {
    $(`#divSearchFilter`).removeClass("d-inline-block")
    $(`#divSearchFilter`).addClass("d-none")
    $(`#btnSearchFilter`).show();
  }
  //================================================================
  changeStatus(param, id, status, param2): void {
    if (param2 == 'changeStatus') {
      status = status ? 1 : 0;
    }
    let statusObj: any = {};
    statusObj.param = param;
    statusObj.id = id;
    statusObj.status = status;
    this.reqRes.postData('/Global/ChangeStatus', statusObj).subscribe(data => {
      if (param == 'status' && param2 == 'delete') {
        let index = this.status.findIndex(item => item.id == id);
        this.status.splice(index, 1);
        toastr.success('Done!', '', { timeOut: 1000 });
      }
      else if (param == 'status' && param2 == 'changeStatus') {
      }
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }
  sortData(type) {
    this.sortType = type;
    this.statusCount = 0;
    this.sortdirection = (this.sortReverse) ? 'A' : 'D';
    this.searchStatus = (this.searchStatus) ? this.searchStatus : '';
    let json = {
      "Search": this.searchStatus,
      "Count": this.statusCount,
      "Direction": this.sortdirection,
      "SortType": this.sortType
    };
    this.getStatus(JSON.stringify(json), 0);
  }

  getSearchData(search) {
    this.searchStatus = (search) ? search : '';
    this.statusCount = 0;
    this.sortType = (this.searchStatus) ? 'scvalue' : 'default';
    let json = {
      "Search": this.searchStatus,
      "Count": this.statusCount,
      "Direction": (this.searchStatus) ? 'A' : 'D',
      "SortType": this.sortType
    };
    $("div[id^=threeNo] button").prop('disabled', false);
    this.getStatus(JSON.stringify(json), 0)
  }

  getStatus(json, ope) {
    this.loading = true;
    let GridParametrs: any = {};
    GridParametrs.type = 'status';
    GridParametrs.json = json;
    this.reqRes.postData('/Settings/GetSettingsViewData', GridParametrs).subscribe(data => {
      this.loading = false;
      this.status = (ope == 0) ? this.status = data.statusData : this.status.concat(data.statusData);
      this.maxCount = data.maxCount;
      //  this._pluginservice.masterSelectedRefresh('roleBulk');
      if (this._pluginservice.checkedList.length == 1) {
        setTimeout(() => {
          $("div[id^= 'threeNo'] button").prop('disabled', true);
          $("#threeNo" + this.checkItemId + " button").prop('disabled', false);
        }, 500)
      } else if (this._pluginservice.checkedList.length > 1) {
        setTimeout(() => {
          $("div[id^= 'threeNo'] button").prop('disabled', true);
        }, 500)
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error); this.loading = false;
      })
  }
  checkItemId: number = 0;
  getCheckedId(id) {
    this.checkItemId = id;
  }

  onScrollData(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop + 1 >= event.target.scrollHeight && this.statusCount <= this.maxCount) {
      this.statusCount = this.statusCount + 25;
      let json = {
        "Search": this.searchStatus,
        "Count": this.statusCount,
        "Direction": this.sortdirection,
        "SortType": this.sortType
      };
      this.getStatus(JSON.stringify(json), 1);
      //$("div[id^=threeNo] button").prop('disabled', false);
      //this._pluginservice.UnCheckAll(this.status);
    }
  }

  modalDelete(delId, delType, delType2, bulkArray) {
    this.delId = delId;
    this.delType = delType;
    this.delType2 = delType2;
    this.delBulkArray = bulkArray;
    if (bulkArray.length == 0) {
      this.delCount = 1;
    } else {
      this.delCount = this._pluginservice.checkedList.length;
    }
    $('#modalDelete').modal('show');
  }

  deleteItem(id, type, type2, array) {
    $("div[id^=threeNo] button").prop('disabled', false);
    $('#modalDelete').modal('hide');
    if (array.length == 0) {
      this.changeStatus(type, id, -1, type2);
    } else {
      let ids = this._pluginservice.bulkActions(array[0]);
      ids.forEach((id) => {
        let index = this.status.findIndex(item => item.id == id);
        this.status.splice(index, 1);
      });
    }
    this._pluginservice.masterSelectedRefresh(`statusBulk`);
  }

  modalDeleteClose() {
    $('#modalDelete').modal('hide');
  }
  //================================================================
  //#region Modal Status
  modalTitle: string = '';
  editStatus(id) {
    this.modalTitle = (id == 0) ? 'New Status' : 'Edit Status';
    this.reqRes.getData('/Settings/GetSettingsEditData/' + id + '/status').subscribe(data => {
      this.statusObj = data;
      //Clone Project Type Modal Information to Temp Obj //
      const cloneOfObject = JSON.parse(JSON.stringify(this.statusObj));
      this.statusObjTemp = cloneOfObject;
      /////////////////////////////////////////////
      $('#statusModal').modal('show');
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  modalStatusClose() {
    let result = this.pluginservice.compareObjects(this.statusObj, this.statusObjTemp, ["id"])
    if (result) {
      if (confirm('Close without saving??')) {
        $('#statusModal').modal('hide');
      }
    }
    else {
      $('#statusModal').modal('hide');
    }
  }
  saveStatus() {
    this._pluginservice.masterSelectedRefresh('statusBulk');
    $('#btnstatus').attr('disabled', 'disabled');
    this.statusObj.order = parseInt(this.statusObj.order);
    this.statusObj.type = parseInt(this.statusObj.type);
    this.reqRes.postData('/Settings/StatusOperation', this.statusObj).subscribe(data => {
      setTimeout(function () {
        $('#btnstatus').removeAttr('disabled');
      }, 1000)
      let returnedObj = data;
      if (this.statusObj.id == 0) {
        this.status.unshift(data);
      }
      else {
        let index = this.status.findIndex(item => item.id == returnedObj.id);
        this.status[index] = returnedObj;
      }
      this.status = this.status.sort((a, b) => a.name.localeCompare(b.name));
      toastr.success('Done!', '', { timeOut: 1000 });
      $('#statusModal').modal('hide');
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  changeType() {
    let index = this.statusObj.typeList.findIndex(item => item.id == this.statusObj.type);
    this.statusObj.order = this.statusObj.type == '' ? 0 : this.statusObj.typeList[index]?.order;
    this.statusObj.statusTitle = this.statusObj.type == '' ? '' : this.statusObj.typeList[index]?.desc;
  }
  //#endregion Status
  //================================================================
}

